import React from "react";
import { useTranslation } from "react-i18next";
import NewsletterForm from "./NewsletterForm";

interface NewsletterSectionProps {
  className?: string;
}

export const NewsletterSection: React.FC<NewsletterSectionProps> = ({
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ backgroundImage: `url("./images/bgmud.jpg")` }}
      className={`bg-cover bg-no-repeat bg-center shadow-md ${className}`}
    >
      <div className="container mx-auto relative py-12 md:py-16 px-4 sm:px-6 lg:px-12 text-white">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Left Column: Benefits & Value Proposition */}
          <div className="lg:col-span-7 space-y-4">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-white leading-tight">
              {t(
                "newsletterSection.title",
                "Prenez une longueur d'avance sur votre bien-être !"
              )}
            </h2>
            <p className="text-white/95 text-base sm:text-lg font-medium">
              {t(
                "newsletterSection.subtitle",
                "Inscrivez-vous gratuitement à notre newsletter et profitez de nombreux avantages :"
              )}
            </p>

            <ul className="space-y-3 pt-2">
              {[1, 2, 3, 4].map((num) => (
                <li key={num} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-5 h-5 mt-0.5 rounded-full bg-white/20 flex items-center justify-center text-white">
                    <svg
                      className="w-3.5 h-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                  <span className="text-white/90 text-sm sm:text-base leading-snug">
                    {t(`newsletterSection.benefit${num}`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column: CTA Card & Form */}
          <div className="lg:col-span-5 bg-white/10 backdrop-blur-xs border border-white/20 rounded-2xl p-6 sm:p-8 flex flex-col items-center text-center shadow-lg">
            <p className="text-white font-semibold text-base sm:text-lg mb-6 leading-relaxed">
              {t(
                "newsletterSection.punchline",
                "Des informations utiles, directement dans votre boîte mail, sans messages superflus !"
              )}
            </p>

            <div className="w-full flex justify-center">
              <NewsletterForm />
            </div>

            <div className="flex items-center justify-center gap-2 mt-4 text-white/80 text-xs sm:text-sm font-medium">
              <svg
                className="w-4 h-4 text-white/90 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
              <span>
                {t(
                  "newsletterSection.reassurance",
                  "Inscription gratuite • Désinscription à tout moment"
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSection;

